import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { SaveButton } from './SaveButton';

export const DeleteButton = (props) => (
    <SaveButton
        icon={faTrash}
        savingLabel="Deleting"
        type="button"
        color="danger"
        {...props}
    />
);